import { DropsButton } from "shared/components/Spor";
import styled from "styled-components";

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
  flex: 2;
`;

// We are using this component in order to steal mouseEvent from trainListElement
export const InvisibleButton = styled(DropsButton)`
  &&& {
    padding: 0px;
    min-height: 0px;
    min-width: 0px;
    background-color: transparent;
  }
  > * > * > * {
    /* Why is it so nested Spor? */
    display: flex;
  }
`;

export const DateHeader = styled.div`
  padding: 5px 35px;
  background-color: transparent;
  width: 100%;
`;
